import { Component, EventEmitter, ElementRef, Input, OnChanges, OnInit, Output, OnDestroy } from '@angular/core';
import { NodeService } from 'apps/ubivu-panel/src/app/serveices/node.service';
import { TopBarService } from 'libs/top-bar/src/lib/top-bar.service';
import { isEmpty } from '@ubi-cell/core-utils';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { CommonTopBar } from './Helper/common-top-bar';
import CommonUtils from 'libs/base/src/lib/utils/common.utils';
import { StorageService } from 'libs/base/src/lib/services/storage.service';
import { SharedService } from 'libs/api/src/lib/services/shared.service';
import { Router } from '@angular/router';
import { TooltipPosition } from '@angular/material/tooltip';
import { GlobalToastService } from 'libs/global-toast/src/lib/services/global-toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ubi-cell-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent implements OnInit, OnChanges, OnDestroy {

  @Input() mainScreen: string = '';
  @Input() subScreen: string = '';
  @Input() displaySubpanel: boolean = false;
  @Input() displayRefreshRate: boolean = false;
  @Input() hideTagFilter: boolean = false;
  @Input() selectedAlertProductType: string = null;
  @Input() workOrderCapabilityType: string = '';
  currSelectedPowerQualityType: any;
  planningPhases: string[];
  currSelectedPhase: string;
  @Input() set selectedPowerQualityType(value: string) {
    this.currSelectedPowerQualityType = this.powerQualityTypes.find(pqType => pqType.key == value)
  }
  @Input() set selectedPhase(value: string) {
    this.currSelectedPhase = value
  }
  currentSubScreen: string = '';
  expandTagBlock : boolean = false;
  expandDropdownBlock : boolean = false;
  topbarSub$: Subscription;
  filterSub$: Subscription;
  appliedFilterSub$: Subscription;
  tagListSub$: Subscription;
  tagListChangeDetect$: Subscription;
  $unsubscribe: Subject<void> = new Subject();
  @Output() topBarButtonAction: EventEmitter<any> = new EventEmitter<any>();
  firstTimeInPage:boolean = true; 
  prevMainScreen:string = '';
  currentView: string = '';
  isTagFilter: boolean = false;
  productTypesList = [];
  selectedProductChip: string = '';

  // power quality
  validPowerQualityScreens = ['power_quality_sustained', 'power_quality_momentary', 'power_quality_voltage'];
  isTagCreationScreen : boolean = false;
  displayTagCreationScreenSub$: Subscription;
  selectedView: string = 'standard';
  powerQualityTypes = [
    { key: 'sustained_outage', value: 'sustained_outages'},
    { key: 'momentary_outage', value: 'momentary_outages'},
    { key: 'voltage_deviation', value: 'voltage_deviations'}
  ];
  
  nodeCountSub$: Subscription;
  nodeCount: number = 0;
  currPQMAPMode= 'standard';
  isSubstationViewEnabled: boolean = false;
  isSubstationViewSelected: boolean = false;
  isSubstationLayerEnabledSub: Subscription;
  
  isFeederViewEnabled: boolean = false;
  isFeederViewSelected: boolean = false;
  isFeederViewEnabledSub: Subscription;
  

  isTemporalViewEnable: boolean = true;
  positionOptions: TooltipPosition = 'above';

  constructor(
    public _topBarConf: TopBarService,
    public _nodeService: NodeService,
    public elementRef: ElementRef,
    private commonTopBar: CommonTopBar,
    public _storageService: StorageService,
    public _sharedService: SharedService,
    private router: Router,
    private _globalToastService: GlobalToastService,
    private _translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.getPQStateDetails();
    this.currentView = this.mainScreen;
    this.productTypesList = this._storageService.getStorageItem('availableProductType') || [];
    this.topbarSub$ = this._topBarConf?.topBarConfigOpt.subscribe(value => {
      if (!isEmpty(value)) {
        this.firstTimeInPage = false;
        this._topBarConf.currTopBarConfig.next(value[this.mainScreen][this.subScreen]);
        this.currentSubScreen = this.subScreen;
        this.prevMainScreen = this.mainScreen

        if(this.mainScreen == 'planning') {
          this.planningPhases = Object.keys(value[this.mainScreen])
        }
      }
    });

    this.filterSub$ = this._topBarConf?.filterConfiguration.subscribe(value => {
      if (!isEmpty(value)) {
        const activeScreen = this.mainScreen === 'planning' ? this.subScreen : this.mainScreen;
        this._topBarConf?.currentFilterConfiguration?.next(value[activeScreen]);
      }
    });

    this.appliedFilterSub$ = this._topBarConf?.filterApplied?.subscribe((appliedFilter) => {
      if (!isEmpty(appliedFilter) && this.mainScreen === 'notifications') {
        this.selectedProductChip = appliedFilter['product_type'] || '';
      }
    });


    this.tagListChangeDetect$ = this._topBarConf?.tagResponseChanged.subscribe(value => {
      if (value == true) {
        if(this.mainScreen == 'notifications'){
          this.getTagList(this.selectedAlertProductType);
        }else{
          this.getTagList(this.mainScreen);
        }
      }
      });

    this.nodeCountSub$ = this._topBarConf.nodeCount.subscribe((res) => {
      if (res || res == 0) {
        this.nodeCount = res;
      }
    });

    // check if tag creation screen is enabled
    this.displayTagCreationScreenSub$ = this._sharedService?.displayTagCreationScreen.subscribe((res) => {
      if (res) {
        this.isTagCreationScreen = res;
      } else {
        this.isTagCreationScreen = false;
      }
    });

    this.isTagFilter = CommonUtils.setPermissionsPerSubpanelEnable(this._storageService);
  }

  
  getPQStateDetails(){
    this.isFeederViewEnabledSub = this._topBarConf.markFeederBtnAsActiveSubject$.subscribe(isEnabled =>{
      this.isFeederViewEnabled = isEnabled.isFeederViewEnabled;
      this.isFeederViewSelected = isEnabled.isFeederViewSelected;
    });

    this._topBarConf.markSubstationBtnAsActiveSubject$.subscribe(isEnabled =>{
      this.isSubstationViewEnabled = isEnabled.isSubstationViewEnabled;
      this.isSubstationViewSelected = isEnabled.isSubstationViewSelected;
    });

    this._topBarConf.isTemporalViewEnableSubject.subscribe(isEnabled =>{
      this.isTemporalViewEnable = isEnabled;
    });

  }

  getTagList(type) {
    this._topBarConf.loadTagComponent = true;
    this.tagListSub$ = this.commonTopBar.getTagList(type)?.subscribe(response => {
      this._topBarConf.tagListResponse = response
      this._topBarConf.tagFilterUpdate.next(true);
    });
  }

  outsideClick(hasClickedOutside) {
    this.expandTagBlock = false;
    this._topBarConf?.expandTagBlock?.next({'expandTagBlock':false});
  }

  onTagBlockExpand() {
    this.expandTagBlock = this.expandTagBlock != true;
    this._topBarConf?.expandTagBlock?.next({'expandTagBlock':this.expandTagBlock});
  }

  // outside click of PQ types dropdown
  dropdownOutsideClick() {
    this.expandDropdownBlock = false;
  }

  // on expansion of PQ types
  onDropdownExpand() {
    this.expandDropdownBlock = this.expandDropdownBlock != true;
  }

  // on change of PQ type
  onSelectPowerQualityType(type) {
    this.currSelectedPowerQualityType = this.powerQualityTypes.find(pqType => pqType.key == type.key)
    const pqRoute = '/pages/power-quality/power-quality-details';
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([pqRoute, this.currSelectedPowerQualityType.key]);
    });
  }

  // on change of Phase type
  onSelectPhaseType(type) {
    this.router.navigate([`/pages/planning/${type}`]);
  }

  // check if power quality screen is enabled
  isPowerQualityScreen(): boolean {
    return this.validPowerQualityScreens.includes(this.mainScreen);
  }

  // on change of standard and temporal view
  onViewClick(tab: string) {
    this.selectedView = tab;
    this._topBarConf.currSelectedMode.next({action: tab});
  }


  toggleFeederView(){
    this.isFeederViewSelected = !this.isFeederViewSelected;
    let feederOpt = {
      show: this.isFeederViewSelected,
      action: 'feeder'
    }
    this._topBarConf.currTopBarActionConfig.next(feederOpt);
  }

  toggleSubstationView(){
    this.isSubstationViewSelected = !this.isSubstationViewSelected;
    if (this.isSubstationViewSelected) {
      const substationLocationMissingMsg = this._translateService.instant('substation_location_missing_msg')
      this._globalToastService.displayCustomToast(substationLocationMissingMsg, 'info');
    }
    const substationOpt = {
      show: this.isSubstationViewSelected,
      action: 'substation'
    }
    this._topBarConf.currTopBarActionConfig.next(substationOpt);
  }
  // set the selected PQ type

  ngOnChanges(): void {
    if (!isEmpty(this._topBarConf?.topBarConfigOpt?.value) && this.mainScreen && this.subScreen) {
      this._topBarConf.currTopBarConfig.next(this._topBarConf.topBarConfigOpt.value[this.mainScreen][this.subScreen]);
      if(this.subScreen !== this.currentSubScreen){
        this.expandTagBlock = false;
        this._topBarConf.expandTagBlock.next({'expandTagBlock':this.expandTagBlock});
        this.currentSubScreen = this.subScreen;
      }
    }
    if (!isEmpty(this._topBarConf?.topBarConfigOpt?.value) && !this.firstTimeInPage && this.mainScreen && this.subScreen) {   
      this.isTagCreationScreen = this._topBarConf?.topBarConfigOpt?.value[this.mainScreen][this.subScreen]?.is_tag_creation;
      this._topBarConf?.currTopBarConfig?.next(this._topBarConf?.topBarConfigOpt?.value[this.mainScreen][this.subScreen]);
    }

    if (!isEmpty(this._topBarConf?.filterConfiguration?.value) && !this.firstTimeInPage && this.prevMainScreen !== this.mainScreen) {
      this._topBarConf?.currentFilterConfiguration?.next(this._topBarConf?.filterConfiguration?.value[this.mainScreen]);
    }

    // Reset Selected view.
    const topBarConfig: any = this._topBarConf.currTopBarConfig.value;
    if (topBarConfig && topBarConfig?.node_status && topBarConfig.node_status?.display_view) {
      topBarConfig.node_status.display_view.selected_view = "chart";
      this._topBarConf.currTopBarConfig.next(topBarConfig);
    }
  }

  ngOnDestroy(): void {
    this.isFeederViewEnabledSub?.unsubscribe();
    this.isSubstationLayerEnabledSub?.unsubscribe();
    this._topBarConf.currSelectedMode.next({});
    this._topBarConf.markFeederBtnAsActiveSubject$.next({ isFeederViewEnabled: false, isFeederViewSelected: false });

    if(this.topbarSub$){
      this.topbarSub$?.unsubscribe();
    }
    if(this.filterSub$){
      this.filterSub$?.unsubscribe();
    }

    if (this.appliedFilterSub$) {
      this.appliedFilterSub$?.unsubscribe();
    }
    this.selectedProductChip = '';

    if(this.tagListChangeDetect$){
      this.tagListChangeDetect$?.unsubscribe();
    }
    if(this.tagListSub$){
      this.tagListSub$?.unsubscribe();
    }

    if(!isEmpty(this._topBarConf?.selectedTagOnCreation)) {
      this._topBarConf.selectedTagOnCreation = [];
    }

    if (this.displayTagCreationScreenSub$) {
      this.displayTagCreationScreenSub$.unsubscribe();
    }

    if (this.nodeCountSub$) {
      this.nodeCountSub$.unsubscribe();
    }

    this._topBarConf.tagListResponse = [];
    this._topBarConf.selectedTagOnNodeStatus = [];
    this._topBarConf?.tagResponseChanged.next(false);
    this._topBarConf?.currTopBarConfig.next(null);
    this._topBarConf?.savedPreferenceTag.next({})
    this._topBarConf?.removeTagSelection.next({})
    this._topBarConf?.tagFilterUpdate.next(false);
    this._topBarConf?.currentFilterConfiguration.next({});
    this._topBarConf.currTopBarActionConfig.next({});
  }

}
